import { render, staticRenderFns } from "./IntegrationHeader.vue?vue&type=template&id=276b14ee&"
import script from "./IntegrationHeader.vue?vue&type=script&lang=ts&"
export * from "./IntegrationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationHeader.vue?vue&type=style&index=0&id=276b14ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports